import { StateTransitionLog } from '../types';

export const isSameWorkflowHistoryMoment = (
  left?: Pick<StateTransitionLog, 'created_at' | 'actor_id'> | null,
  right?: Pick<StateTransitionLog, 'created_at' | 'actor_id'> | null,
): boolean =>
  Boolean(
    left
    && right
    && String(left.created_at || '') === String(right.created_at || '')
    && String(left.actor_id || '') === String(right.actor_id || ''),
  );

export const isWorkflowApprovalToRapimSequence = (
  history: StateTransitionLog[],
  index: number,
): boolean => {
  const item = history[index];
  const nextItem = history[index + 1];
  const thirdItem = history[index + 2];
  const thirdFromState = String(thirdItem?.from_state || '').toLowerCase();
  const thirdToState = String(thirdItem?.to_state || '').toLowerCase();
  const isFinalStepApproval = /^step_\d+_pending$/.test(thirdFromState)
    && thirdToState === thirdFromState.replace('_pending', '_approved');

  return Boolean(
    item
    && nextItem
    && thirdItem
    && item.from_state?.toLowerCase() === 'validasi_l2'
    && item.to_state?.toLowerCase() === 'antrean_rapim'
    && nextItem.from_state?.toLowerCase() === 'validasi_l1'
    && nextItem.to_state?.toLowerCase() === 'validasi_l2'
    && isFinalStepApproval
    && isSameWorkflowHistoryMoment(item, nextItem)
    && isSameWorkflowHistoryMoment(item, thirdItem),
  );
};

export const countVisibleWorkflowTransitions = (history: StateTransitionLog[]): number => {
  let displayCount = 0;

  for (let i = 0; i < history.length; i += 1) {
    if (isWorkflowApprovalToRapimSequence(history, i)) {
      displayCount += 1;
      i += 2;
      continue;
    }

    displayCount += 1;
  }

  return displayCount;
};
